module.exports = __webpack_public_path__ + "static/images/game-logo02.61fd516.png";